import { FC } from "react"
import { Container, Typography } from "@mui/material"
import { useTitle } from "@/core/hooks"
import { TemplatesTable } from "../components/tables"
import { WorkflowStepper } from "../components/stepper/workflowStepper"

export const TemplatesPage: FC = () => {
  useTitle("Шаблоны ответов")
  return (
    <Container maxWidth={false}>
      <WorkflowStepper />
      <Typography variant="h5" mb={2}>
        Шаблоны ответов
      </Typography>
      <TemplatesTable />
    </Container>
  )
}
